import script from "./PollDraftHandler.vue?vue&type=script&setup=true&lang=ts"
export * from "./PollDraftHandler.vue?vue&type=script&setup=true&lang=ts"

import "./PollDraftHandler.vue?vue&type=style&index=0&id=2fe3b388&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe3b388"]])

export default __exports__